import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import maxima from "../../images/maxima.jpg";
import "../../../src/product.css";

const Maxima = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">MAXIMA</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={maxima}
              alt="Bajaj Maxima"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              The world’s largest selling 3 wheeler is now in diesel. It has
              the Most Powerful Engine in the Industry with 12% more POWER and
              17% more Pickup than competition. The vehicle is highly durable
              with long lasting dry clutch, uniaxial balancer for less
              vibrations & reinforced chassis for longer vehicle life. It has
              car Like advanced Features like car type Clutch pedal to handle
              heavy passenger better, 5 speed gear box to handle tough roads
              better, wide seats for Passenger comfort. RE Maxima can bear
              greater load than the rest of its competition and yet is very low
              on maintenance.
            </p>

          </div>
        </section>

        {/* Specifications */}

        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>447.3 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>5 Forward + 1 Reverse Gear</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Diesel</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>505 kg</strong>
            </div>

            <div className="spec-card">
              <span>Max Speed</span>
              <strong>52 Kmph</strong>
            </div>

            <div className="spec-card">
              <span>Passenger Capacity</span>
              <strong>1D + 3</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Maxima;